import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { API } from 'src/environments/environment';

interface DocumentoFinanceiro {
  id: number;
  descricao: string;
  idFinTipoDocumento: number;
  finTipoDocumento: string;
  idFinNaturezaDocumento: number;
  finNaturezaDocumento: string;
}

interface Opcao {
  id: number;
  descricao: string;
}

@Component({
  selector: 'app-fin-documento',
  templateUrl: './fin-documento.component.html',
  styleUrls: ['./fin-documento.component.scss']
})
export class FinDocumentoComponent implements OnInit {
  itens: DocumentoFinanceiro[] = [];
  itensFiltrados: DocumentoFinanceiro[] = [];
  itensPaginados: DocumentoFinanceiro[] = [];
  itemEdicao: DocumentoFinanceiro | null = null;
  modalRef: NgbModalRef | null = null;

  tiposDocumento: Opcao[] = [];
  naturezasDocumento: Opcao[] = [];

  filtroDescricao = '';
  filtroIdFinTipoDocumento = 0;
  filtroIdFinNaturezaDocumento = 0;

  descricao = '';
  idFinTipoDocumento = 0;
  idFinNaturezaDocumento = 0;

  loading = false;
  paginaAtual = 1;
  itensPorPagina = 10;

  constructor(
    private modalService: NgbModal,
    private ajaxService: AjaxService,
    private util: UtilService
  ) {}

  ngOnInit(): void {
    this.carregarOpcoes();
    this.carregar();
  }

  get totalPaginas(): number {
    return Math.ceil(this.itensFiltrados.length / this.itensPorPagina) || 1;
  }

  carregarOpcoes(): void {
    this.ajaxService.get(`${API}financeiro/FinDocumento/ConsultarOpcoes`).subscribe({
      next: (response) => {
        const origem = response?.data ?? response ?? {};
        const data = this.util.converterParaLowercase(origem);
        this.tiposDocumento = this.normalizarLista(data.tiposdocumento).map((x: any) => ({
          id: Number(x.id || 0),
          descricao: String(x.descricao || '')
        })).filter((x: Opcao) => x.id > 0);

        this.naturezasDocumento = this.normalizarLista(data.naturezasdocumento).map((x: any) => ({
          id: Number(x.id || 0),
          descricao: String(x.descricao || '')
        })).filter((x: Opcao) => x.id > 0);
      }
    });
  }

  buscar(): void {
    this.carregar();
  }

  carregar(): void {
    this.loading = true;
    this.util.showLoading();

    const params = new URLSearchParams();
    if (this.filtroDescricao?.trim()) params.set('descricao', this.filtroDescricao.trim());
    if (this.filtroIdFinTipoDocumento > 0) params.set('idFinTipoDocumento', String(this.filtroIdFinTipoDocumento));
    if (this.filtroIdFinNaturezaDocumento > 0) params.set('idFinNaturezaDocumento', String(this.filtroIdFinNaturezaDocumento));

    const query = params.toString();
    const url = `${API}financeiro/FinDocumento/ConsultarFinDocumento${query ? `?${query}` : ''}`;

    this.ajaxService.get(url).subscribe({
      next: (response) => {
        this.loading = false;
        this.util.closeLoading();

        const origem = response?.data ?? response;
        const lista = this.normalizarLista(origem);
        this.itens = lista.map((x: any) => {
          const item = this.util.converterParaLowercase(x || {});
          return {
            id: Number(item.id || 0),
            descricao: String(item.descricao || '').trim(),
            idFinTipoDocumento: Number(item.idfintipodocumento || 0),
            finTipoDocumento: String(item.fintipodocumento || '').trim(),
            idFinNaturezaDocumento: Number(item.idfinnaturezadocumento || 0),
            finNaturezaDocumento: String(item.finnaturezadocumento || '').trim()
          } as DocumentoFinanceiro;
        }).filter((x: DocumentoFinanceiro) => x.id > 0);

        this.itensFiltrados = [...this.itens];
        this.paginaAtual = 1;
        this.atualizarPaginacao();
      },
      error: () => {
        this.loading = false;
        this.util.closeLoading();
        this.itens = [];
        this.itensFiltrados = [];
        this.itensPaginados = [];
        this.util.toasterShowError('Erro', 'Não foi possível carregar documentos.');
      }
    });
  }

  limparFiltros(): void {
    this.filtroDescricao = '';
    this.filtroIdFinTipoDocumento = 0;
    this.filtroIdFinNaturezaDocumento = 0;
    this.carregar();
  }

  novo(): void {
    this.itemEdicao = null;
    this.descricao = '';
    this.idFinTipoDocumento = 0;
    this.idFinNaturezaDocumento = 0;
  }

  editar(item: DocumentoFinanceiro): void {
    this.itemEdicao = item;
    this.descricao = item.descricao;
    this.idFinTipoDocumento = item.idFinTipoDocumento;
    this.idFinNaturezaDocumento = item.idFinNaturezaDocumento;
  }

  abrirModalCadastro(content: TemplateRef<any>, item?: DocumentoFinanceiro): void {
    if (item) {
      this.editar(item);
    } else {
      this.novo();
    }
    this.modalRef = this.modalService.open(content, { size: 'lg' });
  }

  salvar(): void {
    const descricao = String(this.descricao || '').trim();
    if (descricao.length < 2) {
      this.util.toasterShowError('Atenção', 'Informe uma descrição válida.');
      return;
    }
    if (this.idFinTipoDocumento <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione o tipo do documento.');
      return;
    }
    if (this.idFinNaturezaDocumento <= 0) {
      this.util.toasterShowError('Atenção', 'Selecione a natureza do documento.');
      return;
    }

    const payload = {
      id: this.itemEdicao?.id || 0,
      descricao,
      idFinTipoDocumento: this.idFinTipoDocumento,
      idFinNaturezaDocumento: this.idFinNaturezaDocumento
    };

    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinDocumento/Salvar`, payload).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível salvar.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', this.itemEdicao ? 'Registro atualizado com sucesso!' : 'Registro criado com sucesso!');
        this.modalRef?.close();
        this.novo();
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao salvar documento.');
      }
    });
  }

  deletar(item: DocumentoFinanceiro): void {
    this.util.showLoading();
    this.ajaxService.post(`${API}financeiro/FinDocumento/Deletar`, { id: item.id }).subscribe({
      next: (response) => {
        this.util.closeLoading();
        if (response?.hasErrors) {
          this.util.toasterShowError('Erro', response?.message || 'Não foi possível excluir.');
          return;
        }
        this.util.toasterShowSuccess('Sucesso', 'Registro excluído com sucesso!');
        this.carregar();
      },
      error: () => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', 'Erro ao excluir documento.');
      }
    });
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.atualizarPaginacao();
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      this.atualizarPaginacao();
    }
  }

  alterarItensPorPagina(): void {
    this.paginaAtual = 1;
    this.atualizarPaginacao();
  }

  private atualizarPaginacao(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    const fim = inicio + this.itensPorPagina;
    this.itensPaginados = this.itensFiltrados.slice(inicio, fim);
  }

  private normalizarLista(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      if (Object.prototype.hasOwnProperty.call(data, 'id') || Object.prototype.hasOwnProperty.call(data, 'descricao')) {
        return [data];
      }
      return Object.values(data).filter((x: any) => x && typeof x === 'object');
    }
    return [];
  }
}
